export const REFRESH_TIME = 60000;
export const tokenResponseRefreshTime = 2000;